import React from 'react';
import { Typography, Divider, Box } from '@mui/material';
import { STEP2_REQUIRED_FIELDS } from './AddTalent';
import { disponibiliteOptions } from '../../../commun/constants/options';
import DynamicForm from '../../../commun/DynamicForm';
import './Step2Form.css'; 

export default function Step2Form({
  goToNextStep,
  goToPreviousStep,
  formData,
  setFormData,
  errors,
  setErrors,
  devise,
  setDevise
}) {
  const validateFields = () => {
    const newErrors = {};

    STEP2_REQUIRED_FIELDS.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = 'Veuillez remplir ce champ';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateFields()) {
      if (formData.disponibilite === 'autre') {
        if (formData.disponibiliteDate) {
          const updatedFormData = {
            ...formData,
            disponibilite: formData.disponibiliteDate
          };
          delete updatedFormData.disponibiliteDate;
          setFormData(updatedFormData);
          goToNextStep();
        } else {
          setErrors((prev) => ({
            ...prev,
            disponibiliteDate: 'Veuillez renseigner une date de disponibilité'
          }));
          return;
        }
      } else {
        goToNextStep();
      }
    }
  };

  const step2Config = [
    {
      type: 'radio',
      label: 'Ce talent est-il actuellement en poste ?',
      name: 'poste',
      options: [
        { label: 'Oui', value: 'oui' },
        { label: 'Non', value: 'non' }
      ]
    },
    {
      type: 'text',
      label: 'Quel poste occupe-t-il actuellement ?',
      name: 'posteActuelIntitule'
    },
    {
      type: 'text',
      label: 'Dans quelle entreprise ?',
      name: 'entrepriseActuelle'
    },
    {
      type: 'text',
      label: 'Nombre d’années dans ce poste ?',
      name: 'anneesPoste'
    },
    {
      type: 'text',
      label: 'Expérience globale',
      name: 'experienceGlobale'
    },
    {
      type: 'text',
      label: 'Informations complémentaires',
      name: 'informationsComplementaires'
    },
    {
      type: 'select',
      label: 'Disponibilité',
      name: 'disponibilite',
      options: disponibiliteOptions
    },
    {
      type: 'date',
      name: 'disponibiliteDate',
      label: 'Peut être disponible dès :',
      showCondition: (formData) => formData.disponibilite === 'autre'
    }
  ];

  return (
    <Box className="step2-container">
      <Typography variant="h6" className="step2-title">
        Informations professionnelles
      </Typography>
      <Divider className="step2-divider" />

      <DynamicForm
        fields={step2Config}
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
        onNext={handleNextStep}
        onBack={goToPreviousStep}
        additionalProps={{ devise, setDevise }}
      />
    </Box>
  );
}
